import type { IconData } from '@stacksjs/iconify-core'

export const cw4x3: IconData = {
  "body": "<defs><clipPath id=\"SVGo1QMTd8m\"><path fill-opacity=\".7\" d=\"M0 0h682.7v512H0z\"/></clipPath><path id=\"SVGqB82Exhb\" d=\"m0-1l.2.7H1L.3 0l.2.7L0 .4l-.6.4l.2-.7l-.5-.4h.7z\"/></defs><g clip-path=\"url(#SVGo1QMTd8m)\" transform=\"scale(.94)\"><path fill=\"#002b7f\" d=\"M0 0h768v512H0z\"/><path fill=\"#f9e814\" d=\"M0 320h768v64H0z\"/><use width=\"13500\" height=\"9000\" x=\"2\" y=\"2\" fill=\"#fff\" href=\"#SVGqB82Exhb\" transform=\"scale(42.67)\"/><use width=\"13500\" height=\"9000\" x=\"3\" y=\"3\" fill=\"#fff\" href=\"#SVGqB82Exhb\" transform=\"scale(56.9)\"/></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default cw4x3
